var _circle, _path, _circle2, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDetailedClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 10.25,
    transform: "rotate(-90 15 15)",
    fill: "#FFD24C",
    stroke: "#0A0B0F",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 25c5.523 0 10-4.477 10-10H5c0 5.523 4.477 10 10 10z",
    fill: "#C90"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    transform: "rotate(-90 15 15)",
    fill: "#F0F1F5",
    r: 7.778
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 22.778A7.778 7.778 0 0 0 22.778 15H7.222A7.778 7.778 0 0 0 15 22.778z",
    fill: "#C2C7D6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.757 15.566a7.778 7.778 0 1 0-15.514 0 7.778 7.778 0 0 1 15.514 0z",
    fill: "#858FAD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 11.963c.327 0 .593.265.593.593v2.962h1.777a.593.593 0 0 1 0 1.186H15a.593.593 0 0 1-.592-.593v-3.556c0-.327.265-.592.592-.592z",
    fill: "#332600"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailedClock);
export default __webpack_public_path__ + "static/media/detailed_clock.b1e201c5981019b84f20ecc5557c687d.svg";
export { ForwardRef as ReactComponent };